import { useEffect, useState } from 'react';

type ResponsiveTaskLayout = {
  width: number;
  isNarrowDesktop: boolean;
  isTablet: boolean;
  isCompact: boolean;
  pagePadding: string;
};

const DEFAULT_WIDTH = 1600;

const getViewportWidth = (): number => {
  if (typeof window === 'undefined' || typeof window.innerWidth !== 'number') {
    return DEFAULT_WIDTH;
  }
  return window.innerWidth;
};

export const useResponsiveTaskLayout = (): ResponsiveTaskLayout => {
  const [width, setWidth] = useState<number>(() => getViewportWidth());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleResize = () => {
      setWidth(getViewportWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isCompact = width <= 720;
  const isTablet = width <= 880;
  const isNarrowDesktop = width <= 1280;

  let pagePadding = '2.5rem 3rem 4rem';
  if (isCompact) {
    pagePadding = '1rem 1rem 2rem';
  } else if (isTablet) {
    pagePadding = '1.5rem 1.25rem 2.5rem';
  } else if (isNarrowDesktop) {
    pagePadding = '2rem 1.75rem 3rem';
  }

  return {
    width,
    isNarrowDesktop,
    isTablet,
    isCompact,
    pagePadding
  };
};
